import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import _ from "lodash";
import { OrderGrid, ServiceThreadSpinner } from ".";
import { api, constants, dateHelpers, helpers } from "../utils";

const defaultPageSize = 10;

export default function CurrentOrders(props) {
   const [customerId, setCustomerId] = useState(props.customerId);
   const [data, setData] = useState();
   const [loaded, setLoaded] = useState(false);
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(defaultPageSize);
   const [sortDirection, setSortDirection] = useState("asc");
   const [sortField, setSortField] = useState("requiredShipDate");
   const [totalPages, setTotalPages] = useState();
   const [totals, setTotals] = useState();

   useEffect(() => {
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId);
         setPage(1);
         setTotalPages(0);
         setLoaded(false);
      }

      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId]);

   function createPayload() {
      let payload = {
         StartDate: dateHelpers.formatDateForServerSafari(
            dateHelpers.currentDate()
         ),
         EndDate: dateHelpers.formatDateForServerSafari(
            dateHelpers.getLookbackByYears(-10)
         ),
         DateRangeType: constants.DATE_RANGE_TYPE.EndShipDateOnly,
         ExcludePallets: true,
         CustomerId: customerId,
         PageNumber: page,
         PageSize: pageSize,
         SortField: sortField,
         SortDirection: sortDirection,
      };
      return payload;
   }

   function exportXlsx() {
      const payload = createPayload();
      api
         .postGetBlob("Customer/ExportCustomerOrdersXLSX", payload)
         .then((r) => {
            if (r.data) {
               const XLSX_FILENAME = `${payload.CustomerId}_Current_Orders.xlsx`;
               helpers.downloadExport(
                  r.data,
                  XLSX_FILENAME,
                  constants.MIME_TYPES.xlsx
               );
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post(
            `Customer/GetPaginatedCurrentOrders`,
            createPayload()
         )
         .then((response) => {
            if (response.data.success) {
               setData(response.data.orders.items);
               setTotalPages(
                  _.ceil(response.data.orders.totalCount / (pageSize || 10))
               );
               setTotals(response.data.totals);
            }
            setLoaded(true);
         })
         .catch(api.catchHandler);
   }

   function onPageChange(page) {
      setPage(page);
      setLoaded(false);
   }

   function onPageSizeChange(size) {
      setPageSize(size);
      setTotalPages(null);
      onPageChange(1);
   }

   function onSortChange(field, direction) {
      if (field !== sortField) {
         setSortField(field);
         setSortDirection("asc");
      } else {
         setSortDirection(direction);
      }
      onPageChange(1);
   }

   return (
      <>
         <div>
            <span className="h2 me-2">Current Orders</span>{" "}
            <span className="text-muted">
               Customer #{customerId}
            </span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {data && data.length ? (
               <OrderGrid
                  data={data}
                  totals={totals}
                  sortCallback={onSortChange}
                  sortField={sortField}
                  sortDirection={sortDirection}
                  pagerCallback={onPageChange}
                  pageNumber={page}
                  totalPages={totalPages}
                  exportXlsxCallback={exportXlsx}
                  pageSize={pageSize}
                  allowAll
                  sizeCallback={onPageSizeChange}
                  defaultPageSize={defaultPageSize}
               />
            ) : (
               <span className="h5">No Open Orders</span>
            )}
         </ServiceThreadSpinner>
      </>
   );
}
